import React, { useState, useEffect } from "react";
import { Button, Card, Col, Input, Modal, ModalBody, Row } from "reactstrap";
import { Link } from "react-router-dom";
import Dropzone from "react-dropzone";
import ShowCard from "../Document/ShowCard";
import toast from "react-hot-toast";
import axios from "axios";
import CooperativeService from "../../../services/CooperativeService";
import CoopteamService from "../../../services/COOPServices/CoopteamService";
import DeleteModal from "../Document/DeleteDocument";

const LekhaSuparibechan = () => {
  const [showform, setShowForm] = useState(false);
  const [showform1, setShowForm1] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [data, setData] = useState([]);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [coopteamID, setCoopteamId] = useState(null);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const toggleModal1 = () => {
    setModalOpen1(!modalOpen1);
  };

  const [currentMember, setCurrentMember] = useState({
    Name: "",
    Designation: "",
    Image: null,
    TeamType: 2, // Assuming this is default
    CoopId: "", // Will be populated after user fetch
  });

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [coopList, setCoopList] = useState([]);

  // Fetch user and coopId from localStorage
  const user = JSON.parse(localStorage.getItem("user"));
  const userImage = user?.user?.image;
  const coopId = user?.user?.cooperative_id;
  const userImageExtension = user?.user?.imageExtension;
  const imageSrc = userImageExtension
    ? `data:image/${userImageExtension.replace(".", "")};base64,${userImage}`
    : "No Image";
  const token = user?.accessToken;

  const handleBack = () => {
    setShowForm(false);
    toggleModal1();
  };

  // Handle input change for member details
  const handleInputChange = (e, field) => {
    setCurrentMember((prevMember) => ({
      ...prevMember,
      [field]: e.target.value,
    }));
  };

  const handleClickAddMember = () => {
    setShowForm(true);
    toggleModal1();
  };

  // Handle file drop and add to selectedFiles
  const handleAcceptedFiles = (files) => {
    const formattedFiles = files.map((file) => ({
      ...file,
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    }));
    setSelectedFiles((prevFiles) => [...prevFiles, ...formattedFiles]);
    setCurrentMember((prevMember) => ({
      ...prevMember,
      Image: files[0],
    }));
  };

  // Format bytes utility function
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  // Handle removing file from selectedFiles
  const handleFileRemove = (indexToRemove) => {
    setSelectedFiles((prevFiles) =>
      prevFiles.filter((file, index) => index !== indexToRemove)
    );
  };

  //get the team detail from the id
  useEffect(() => {
    fetchCooperativeDetails();
  }, [coopId]);

  const fetchCooperativeDetails = async () => {
    try {
      const response = await CooperativeService.getById(coopId);
      setCoopList(response || []);
    } catch (error) {
      console.error("Error fetching cooperative details:", error);
      toast.error("Failed to fetch cooperative details.");
    }
  };
  const handleAddMember = () => {
    const newMember = { ...currentMember, files: selectedFiles };
    if (
      currentMember.Name &&
      currentMember.Designation &&
      currentMember.Image
    ) {
      setData((prevData) => [...prevData, newMember]);
      setShowForm(false);
      // setShowForm1(true);
      setCurrentMember({
        Name: "",
        Designation: "",
        Image: currentMember.Image,
        TeamType: 2,
        CoopId: coopId,
      });
      setSelectedFiles([]);
      toast.success("Member Added Successfully!");
    } else {
      console.log("error", error);
      toast.error("Name, Designation, and Image are required!");
    }
  };

  // Handle adding a new member
  const handleAddSave = async () => {
    try {
      const formData = new FormData();
      formData.append("Name", currentMember.Name);
      formData.append("Designation", currentMember.Designation);
      formData.append("TeamType", currentMember.TeamType);
      formData.append("CoopId", coopId);
      formData.append("Image", currentMember.Image);

      const response = await axios.post(
        "http://api.dsccou.sebs.asia/api/coopteam",
        formData,
        {
          headers: {
            "Content-type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toggleModal1(); // Close the modal

      handleAddMember();
      fetchCooperativeDetails(); // Fetch the updated list

    } catch (error) {
      console.log("error", error);
      toast.error("Failed to add member. Please try again.");
    }
  };

  // delete team item
  const handleDelete = async () => {
    if (coopteamID) {
      try {
        await CoopteamService.delete(coopteamID);
        toast.success("Document Removed Successfully!");
        toggleDelete();
        fetchCooperativeDetails();
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error("Failed to delete document.");
      }
    } else {
      setShowForm1(false);
      setData([]);
    }
  };
  const handleDeleteTeam = (id) => {
    setCoopteamId(id);
    toggleDelete();
  };
  const toggleDelete = () => {
    setIsDeleteOpen(!isDeleteOpen);
  };

  return (
    <>
      <Row>
        <Modal isOpen={modalOpen1} toggle={toggleModal1} size="sm">
          <ModalBody>
            <div
              style={{ width: "260px", height: "450px", textAlign: "center" }}
            >
              <Dropzone onDrop={handleAcceptedFiles}>
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone dz-clickable pt-4">
                    <div
                      className="dz-message needsclick mb-5 p-3"
                      {...getRootProps()}
                    >
                      <i className="align-item-center display-4 text-muted ri-upload-cloud-2-fill" />
                      <input {...getInputProps()} />
                      <h6 className="fs-15 fw-semi-bold pt-3">
                        Drop files here or <Link to="#">click to upload.</Link>
                      </h6>
                      <div className="list-unstyled mb-0" id="file-previews">
                        {selectedFiles.map((f, i) => (
                          <Card
                            className="mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div>
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="100"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                                <Col>
                                  <Link
                                    to="#"
                                    className="text-muted font-weight-bold"
                                  >
                                    {f.name}
                                  </Link>
                                  <p className="mb-0 fs-12">
                                    {f.formattedSize}
                                  </p>
                                </Col>
                                <Col lg={2}>
                                  <Link onClick={() => handleFileRemove(i)}>
                                    <h6>
                                      <i className="ri-delete-bin-2-line text-danger"></i>
                                    </h6>
                                  </Link>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>

              <div className="pt-2">
                <Input
                  type="text"
                  className="form-control pt-2"
                  value={currentMember.Name}
                  placeholder="Enter Name"
                  onChange={(e) => handleInputChange(e, "Name")}
                />
              </div>
              <div className="pt-2">
                <Input
                  type="text"
                  className="form-control pt-2"
                  value={currentMember.Designation}
                  placeholder="Enter Designation"
                  onChange={(e) => handleInputChange(e, "Designation")}
                />
              </div>
              <div className="d-flex pt-2 gap-1">
                <Button
                  color="danger"
                  className="w-100 text-center"
                  onClick={handleBack}
                >
                  Back
                </Button>
                <Button
                  color="success"
                  className="w-100 text-center"
                  onClick={handleAddSave}
                >
                  Save
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Col xs={12}>
          <div className="d-flex gap-4 flex-wrap" style={{ padding: "6px" }}>
            {showform1 &&
              data.map((member, index) => (
                <Card
                  key={index.id}
                  className=" mb-3 text-center d-flex flex-column justify-content-center align-items-center"
                  style={{
                    width: "230px",
                    height: "260px",
                  }}
                >
                  {member.Image && (
                    <div
                      className="w-100"
                      style={{
                        maxWidth: "240px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxHeight: "140px",
                        minHeight: "140px",
                      }}
                    >
                      <img
                        src={URL.createObjectURL(member.Image)}
                        alt="Avatar"
                        style={{ maxWidth: "150px" }}
                      />
                    </div>
                  )}
                  <h5 className="text-center fs-15 pt-1">{member.Name}</h5>
                  <h5 className="text-center fs-12 text-muted pt-1">
                    {member.Designation}
                  </h5>
                  <div className="d-flex gap-3">
                    <Button
                      className="rounded-circle btn btn-soft-danger btn-sm gap-1"
                      color="danger"
                      aria-label="Delete Team Member"
                      onClick={() => handleDeleteTeam(member.id)}
                    >
                      <i className="ri-delete-bin-2-line"></i>
                    </Button>
                  </div>
                </Card>
              ))}

            {coopList?.lekhaSuparibechanCommittee?.map((item, index) => (
              <Card
                className=" mb-3 text-center d-flex flex-column justify-content-center align-items-center"
                style={{
                  width: "230px",
                  height: "260px",
                }}
                key={item.id}
              >
                <div
                  className="w-100"
                  style={{
                    maxWidth: "240px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    maxHeight: "140px",
                    minHeight: "140px",
                  }}
                >
                  <img
                    src={`data:image/jpeg;base64,${item.image}`}
                    style={{ maxWidth: "150px" }}
                    alt="Avatar"
                    className="img-fluid"

                  />
                </div>
                <h5 className="text-center  pt-2">{item.name}</h5>
                <h6 className="text-center  ">{item.designation}</h6>
                <div className="d-flex gap-3">
                  <Button
                    className="rounded-circle btn btn-soft-danger btn-sm gap-1"
                    color="danger"
                    aria-label="Delete Team Member"
                    onClick={() => handleDeleteTeam(item.id)}
                  >
                    <i className="ri-delete-bin-2-line"></i>
                  </Button>
                </div>
              </Card>
            ))}

            <Card
              style={{
                paddingTop: "110px",
                width: "210px",
                height: "260px",
                textAlign: "center",
              }}
            >
              <Link onClick={handleClickAddMember}>
                <h1>
                  <i className="bx bx-plus-circle text-center"></i>
                </h1>
              </Link>
              <h5 className="text-center">Add Member</h5>
            </Card>
          </div>
        </Col>
      </Row>
      <DeleteModal
        deleteTerm={"team member"}
        handleDelete={handleDelete}
        isOpen={isDeleteOpen}
        toggle={toggleDelete}
      />
      <ShowCard isOpen={modalOpen} toggle={toggleModal} />
     
    </>
  );
};

export default LekhaSuparibechan;
